import {useEffect, useRef, useState} from "react";
import {API_BASE_URL, convertRemToPixels} from "../ConstantsAndHelper";

function CourseOverview({enterCourse, emailUser, setEmailUser, verificationCode, setVerificationCode}) {
    const [courses, setCourses] = useState([]);
    const [errorLoadingText, setErrorLoadingText] = useState("");
    const [numCardsPerRow, setNumCardsPerRow] = useState(3);
    const mainDivRef = useRef(null);

    const base64EncodedAuthHeader = btoa( "courseOverview " + emailUser.trim() + " " + verificationCode.trim());

    useEffect(() => {
        fetch(`${API_BASE_URL}/course`, {
            method: "GET",
            headers: {
                "Authorization": base64EncodedAuthHeader
            }
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error(response.status.toString());
                } else {
                    setErrorLoadingText("");
                    return response;
                }
            })
            .then(response => response.json())
            .then(data => setCourses(data))
            .catch((error) => {
                if(error.message === "401"){
                    setErrorLoadingText("Der Verifizierungscode ist nicht korrekt oder abgelaufen. Bitte versuchen Sie den Login erneut.");
                } else {
                    setErrorLoadingText("Die Kurse sind aktuell nicht verfügbar. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.");
                }
                setEmailUser("");
                setVerificationCode("");
                // console.log('error: ' + error);
            });

        let maxWidth = mainDivRef.current.clientWidth;
        setNumCardsPerRow(Math.floor(maxWidth / convertRemToPixels(19 + 1)));
    }, [base64EncodedAuthHeader, setEmailUser, setVerificationCode]);

    let courseCardsRows = [];
    let courseCardsCounter = 1;
    let courseCards = [];
    for (let c of courses) {
        let courseTags = [];

        for (let t of c.tags) {
            let {term} = t;
            courseTags.push(<span key={"tag-" + t.id} className="badge text-bg-secondary"
                                  style={{margin: '0.2rem'}}>{term}</span>);
        }

        let image = "";
        if (c.image !== null) {
            image = <img src={"data:" + c.image.mimeType + ";base64," + c.image.content}
                         alt="" height="35"/>;
        }

        courseCards.push(
            <div key={"col-auto-" + c.id} className="col-auto" style={{padding: '0'}}>
                <div key={"courseCard-" + c.id} className="card"
                     style={{width: '19rem', margin: '1rem', textAlign: 'center'}}>
                    <div className="card-body">
                        <h1 className="card-title">
                            {image}
                        </h1>
                        <h3 className="card-title" style={{marginBottom: '1rem'}}>
                            {c.name}
                        </h3>
                        {courseTags}
                        <p className="card-text">
                            {c.description}
                        </p>
                        <button type="button" className="btn btn-outline-primary" onClick={() => enterCourse(c)}><i
                            className="bi bi-door-open"></i> Kurs betreten
                        </button>
                    </div>
                </div>
            </div>
        );

        if ((courseCardsCounter % numCardsPerRow === 0) || (courseCardsCounter === courses.length)) {
            courseCardsRows.push(<div key={"card-row-" + courseCardsCounter} className="row justify-content-center">
                {courseCards}
            </div>);
            courseCards = [];
        }

        courseCardsCounter++;
    }

    let courseContent = <div className="spinner-border" role="status"><span
        className="visually-hidden">Loading...</span></div>;
    if (errorLoadingText !== "") {
        courseContent = <div className="d-flex justify-content-center">
            <div className="alert alert-secondary mt-3" role="alert">
                <i className="bi bi-exclamation-triangle"></i> {errorLoadingText}
            </div>
        </div>;
    } else if (courseCardsRows.length > 0) {
        courseContent = <div className="d-flex justify-content-center">
            <div className="container">
                {courseCardsRows}
            </div>
        </div>;
    }

    return (
        <div ref={mainDivRef}>
            {courseContent}
        </div>
    );
}

export default CourseOverview;